import api from './api';

export interface StudentAction {
  id?: number;
  student: number;
  student_name?: string;
  action_type: 'session_added' | 'exercise_evaluated' | 'session_moved';
  action_type_display?: string;
  session?: number | null;
  session_name?: string;
  exercise_evaluation?: number | null;
  evaluation_details?: any;
  description: string;
  created_by?: number;
  created_by_name?: string;
  created_at?: string;
}

class StudentActionService {
  async getAll(params?: any): Promise<StudentAction[]> {
    const response = await api.get('/student-actions/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getAction(id: number): Promise<StudentAction> {
    const response = await api.get(`/student-actions/${id}/`);
    return response.data;
  }

  async create(data: Partial<StudentAction>): Promise<StudentAction> {
    const response = await api.post('/student-actions/', data);
    return response.data;
  }

  async logSessionAdded(studentId: number, sessionId: number): Promise<StudentAction> {
    const response = await api.post('/student-actions/log_session_added/', {
      student: studentId,
      session: sessionId,
    });
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/student-actions/${id}/`);
  }
}

const studentActionService = new StudentActionService();
export default studentActionService;
